import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import cx from 'classnames';

import { Button } from '../../components/_shared';
import AccountLayout from '../../components/layout/Account';
import UserInfoForm from './UserInfoForm';
import {
  makeSelectUser,
  makeSelectAuthProceeding,
} from '../../store/selectors';
import { updateUserInit } from '../../store/actions/user';
import ChangePasswordModal from './ChangePasswordModal';
import { changePassword } from '../../service/user';

const Tabs = [
  {
    key: 'general',
    label: 'Profile Information',
  },
  // {
  //   key: 'billing',
  //   label: 'Billing Information',
  // },
];

const Profile = () => {
  const user = useSelector(makeSelectUser());
  const isProceeding = useSelector(makeSelectAuthProceeding());
  const dispatch = useDispatch();
  const [currentTab, setCurrentTab] = useState('general');
  const [showModal, setShowModal] = useState(false);
  const [error, setError] = useState('');

  const handleSelectTab = (tab) => () => setCurrentTab(tab);
  const handleSubmitUserInfo = (data) =>
    dispatch(updateUserInit({ id: user._id, ...data }));
  const handleChangePassword = async (data) => {
    if (data.password !== data.confirmPassword) {
      setError('Password does not match');
      return;
    }

    try {
      const res = await changePassword(data.password);

      if (res && res.data) {
        alert('Password has been changed successfully.');
        handleCloseModal();
      } else {
        alert('Failed to change password.');
        setError(res.data.error);
      }
    } catch (err) {
      alert('Failed to change password.');
      setError(err);
    }
  };
  const handleCloseModal = () => setShowModal(false);
  const handleOpenModal = () => setShowModal(true);

  return (
    <AccountLayout>
      <div className="text-lg font-semibold text-black tracking-widest sm:text-xl sm:ml-4">
        Edit Account Details
      </div>
      <div className="p-4 mt-3">
        <div className="mb-6 w-full">
          <div className="flex items-center sm:px-0">
            {Tabs.map((tab) => (
              <div
                key={tab.key}
                className={cx(
                  tab.key === currentTab &&
                    'font-semibold text-black border-b-2 border-solid border-black',
                  tab.key !== currentTab && 'text-gray-200',
                  'w-1/2 text-center cursor-pointer text-regular uppercase tracking-widest py-2 sm:text-sm'
                )}
                onClick={handleSelectTab(tab.key)}
              >
                {tab.label}
              </div>
            ))}
          </div>
        </div>
        <div className="overflow-auto flex-grow">
          {currentTab === 'general' && (
            <div>
              <div className="w-full flex items-center -mx-3 sm:flex-col">
                <div className="w-1/2 px-3 sm:w-full">
                  <UserInfoForm
                    isBusy={isProceeding}
                    data={user}
                    onSubmit={handleSubmitUserInfo}
                  />
                </div>
                <div className="w-1/2 px-3 flex justify-center sm:w-full sm:mt-3">
                  <Button
                    className="sm:w-full px-4 rounded-lg"
                    caption="Change Password"
                    onClick={handleOpenModal}
                  />
                </div>
                <ChangePasswordModal
                  open={showModal}
                  error={error}
                  onSubmit={handleChangePassword}
                  onClose={handleCloseModal}
                />
              </div>
            </div>
          )}
          {/* {currentTab === 'billing' && (
            <div className="h-32 flex items-center justify-center">
              <h3 className="mb-6 text-2xl text-center font-bold">
                (Coming soon...)
              </h3>
            </div>
          )} */}
        </div>
      </div>
    </AccountLayout>
  );
};

export default Profile;
